export interface Group {
  id: number
  name: string
  organizationId: number
  ancestorIds: number[] //顶级 group ancestorIds 为 []
  type: GroupType
}

export enum GroupType {
  Creator = 'Creator',
  Employee = 'Employee',
}
